export const formatPrice = n => n.toLocaleString('en-US').replaceAll(',', "'")

export const addPrefixAndSuffix = (string, prefix, suffix) => {
  let result = string

  if (prefix) {
    result = `${prefix} ${result}`
  }
  if (suffix) {
    result = `${result} ${suffix}`
  }

  return result
}
